import clsx from "clsx";
import type { PropsWithChildren } from "react";

type DrawerContentProps = PropsWithChildren<{ noXPadding?: boolean }>;

export function DrawerContent({ children, noXPadding }: DrawerContentProps) {
  return (
    <div
      className={clsx(
        "isolate flex grow-1 flex-col p-main pt-2 first:pt-main last:pb-0",
        {
          "px-0": noXPadding,
        },
      )}
    >
      {children}
    </div>
  );
}
